import React from "react";
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

const Topnav = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language.startsWith("fr") ? "FR" : "EN";
    return (
        <div className="container-fluid marginTop overflowYHidden">
            <Navbar expand="lg" className="navbar-custom" fixed="top">
                <Container>
                    <Navbar.Brand>
                        <div className="fs-4 fw-bold pe-5 name topnavName">
                            Sophie Garant-Ducas
                            <p className="petitNav">{t("job.title")}</p>
                        </div>
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto mx-0 mx-md-auto me-3">
                            <Nav.Link href="/">{t('onglet.accueil')}</Nav.Link>
                            <Nav.Link href="/projets">{t('onglet.projets')}</Nav.Link>
                            <Nav.Link href="/nouvelles">{t('onglet.nouvelles')}</Nav.Link>

                        </Nav>
                        <NavDropdown
                            title={currentLang}
                            id="language-dropdown"
                            className="language-dropdown">
                            <NavDropdown.Item onClick={() => i18n.changeLanguage("fr")}>
                                FR
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => i18n.changeLanguage("en")}>
                                EN
                            </NavDropdown.Item>
                        </NavDropdown>
                        <a href="/contact" className="buttonNav mx-0 d-lg-inline-block">
                            {t('btn.contacter')}
                        </a>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
}

export default Topnav;